import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { max: Number }

  connect() {
    this.trim()
    this.observer = new MutationObserver(() => this.trim())
    this.observer.observe(this.element, { childList: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  trim() {
    const max = this.maxValue || 5
    while (this.element.children.length > max) {
      this.element.lastElementChild.remove()
    }
  }
}
